/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Field_GridInputs */

const cs_builder_block_field_grid = /** @type {(inputs: Builder_Block_Field_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mřížka polí`)
};

const en_builder_block_field_grid = /** @type {(inputs: Builder_Block_Field_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field grid`)
};

/**
* | output |
* | --- |
* | "Field grid" |
*
* @param {Builder_Block_Field_GridInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_field_grid = /** @type {((inputs?: Builder_Block_Field_GridInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Field_GridInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_field_grid(inputs)
	return cs_builder_block_field_grid(inputs)
});